<template>
  <v-card>
    <v-tabs-window v-model="tabsStore.activeTab">

      <v-tabs-window-item :value="Tab.CATEGORY">
        <v-container fluid>
          <v-row>
            <CategoryGrid />
          </v-row>
        </v-container>
      </v-tabs-window-item>

      <v-tabs-window-item :value="Tab.PRODUCT">
        <v-container fluid>
          <v-row>
            <ProductGrid />
          </v-row>
        </v-container>
      </v-tabs-window-item>


      <v-tabs-window-item :value="Tab.PAGE">
        <v-container fluid>
          <v-row>
            <PageGrid />
          </v-row>
        </v-container>
      </v-tabs-window-item>

      <v-tabs-window-item :value="Tab.OTHER">
        <v-container fluid>
            <OtherGrid />
        </v-container>
      </v-tabs-window-item>

      <v-tabs-window-item :value="Tab.CATEGORY_HUB">
        <v-container fluid>
            <CategoryHubGrid />
        </v-container>
      </v-tabs-window-item>

      <v-tabs-window-item :value="Tab.IMAGES">
        <v-container fluid>
          <v-row>
            <v-col>
              <ImageGrid />
            </v-col>
          </v-row>
        </v-container>
      </v-tabs-window-item>
    </v-tabs-window>
  </v-card>
</template>

<script lang="ts" setup>
import { Tab } from '@/enums/Tab';

// Components
import CategoryGrid from '@/components/CategoryGrid.vue';
import ProductGrid from '@/components/ProductGrid.vue';
import PageGrid from '@/components/PageGrid.vue';
import OtherGrid from '@/components/OtherGrid.vue';
import CategoryHubGrid from '@/components/CategoryHubGrid.vue';
import ImageGrid from '@/components/ImageGrid.vue';

import { useTabsStore } from '@/store/tabsStore';

const tabsStore = useTabsStore();
</script>